import { Flex } from 'foundations-components/components/Flex';
import { DocumentsIcon } from 'foundations-assets/icons/components/DocumentsIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export default function EmptyDocumentThumbnail() {
  return /*#__PURE__*/_jsx(Flex, {
    justifyContent: "center",
    alignItems: "center",
    blockSize: "140px",
    inlineSize: "140px",
    borderWidth: "100",
    borderColor: "border-core-default",
    borderStyle: "solid",
    backgroundColor: "fill-field-default",
    "data-test-id": "empty-document-thumbnail",
    children: /*#__PURE__*/_jsx(DocumentsIcon, {
      size: "900",
      color: "icon-primary-disabled"
    })
  });
}